import React, { FC } from 'react';
import { Input, Dropdown } from 'semantic-ui-react';
import { XaiVoiceSettings } from '../../../../core/api/VoiceConfig';
import { SettingsContainer, SettingRow, Label, SliderContainer, ValueDisplay } from './styles';

export interface Props {
  settings: XaiVoiceSettings;
  onChange: (settings: XaiVoiceSettings) => void;
}

const latencyOptions = [
  { key: 0, value: 0, text: 'Best quality' },
  { key: 1, value: 1, text: 'Lower latency' }
];

export const XaiSettings: FC<Props> = ({ settings, onChange }) => {
  const handleChange = (key: keyof XaiVoiceSettings, value: any) => {
    onChange({
      ...settings,
      [key]: value
    });
  };

  const handleOptionChange = (key: keyof XaiVoiceSettings["options"], value: any) => {
    onChange({
      ...settings,
      options: {
        ...settings.options,
        [key]: value
      }
    });
  };

  return (
    <SettingsContainer>
      <SettingRow>
        <SliderContainer>
          <Label>Speed</Label>
          <Input
            type="range"
            min={0.7}
            max={1.5}
            step={0.1}
            value={settings.speed}
            onChange={(e) => handleChange('speed', parseFloat(e.target.value))}
          />
          <ValueDisplay>{settings.speed.toFixed(1)}</ValueDisplay>
        </SliderContainer>
      </SettingRow>

      <SettingRow>
        <Label>Streaming Mode</Label>
        <div style={{ display: 'flex', gap: '8px' }}>
          <div style={{ flex: 1 }}>
            <Dropdown
              selection
              fluid
              options={latencyOptions}
              value={settings.options.optimize_streaming_latency ?? 1}
              onChange={(_, { value }) => handleOptionChange('optimize_streaming_latency', value as number)}
            />
          </div>
        </div>
      </SettingRow>
    </SettingsContainer>
  );
};
